import { ContractorInterface } from '@ecommerce/lib-interfaces';
import { WebsiteInterface } from '@core/website';
import { StatusType } from '@core/interfaces';
import { StateType } from '@core/interfaces/state-type.interface';

export interface ServiceInterface<T = Record<string, unknown>> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
    type: ServiceType;
    status: ServiceStatus;
    state: ServiceState[] | null;
    currentState?: ServiceCurrentState | null;
    config: T;
    contractorPaymentMethodId: number;
    utmSource?: string | null;
}

export type ServiceCreateInterface<T = Record<string, unknown>> = Pick<ServiceInterface<T>, 'type' | 'config' | 'utmSource'>
    & { contractorId: ContractorInterface['id']; }
    & { websiteId: WebsiteInterface['id']; };

export type ServiceUpdateInterface<T = Record<string, unknown>> = Pick<ServiceInterface<T>, 'type'>
    & Partial<Pick<ServiceInterface<T>, 'config' | 'status' | 'contractorPaymentMethodId'>>
    & { contractorId: ContractorInterface['id']; }
    & { websiteId: WebsiteInterface['id']; };

export enum ServiceType {
    SKAPIEC = 'SKAPIEC',
    FEED = 'FEED',
    PIXEL = 'PIXEL',
    CONTENT_COMMERCE = 'CONTENT_COMMERCE',
    RETAIL_MEDIA = 'RETAIL_MEDIA',
    RETAIL_MEDIA_PARTNER = 'RETAIL_MEDIA_PARTNER',
    LAMODA = 'LAMODA',
    OPINEO = 'OPINEO',
    VIDEO_ADS = 'VIDEO_ADS',
    PERFORMANCE_EASY = 'PERFORMANCE_EASY',
    MAILING = 'MAILING',
    MAILING_INBOX = 'MAILING_INBOX',
    MAILING_RETARGETING = 'MAILING_RETARGETING'
}

export enum ServiceStatus {
    CREATING = 'CREATING',
    PROCESSING = 'PROCESSING',
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    ERROR = 'ERROR',
    INVALID = 'INVALID',
    BLOCKED = 'BLOCKED',
    NOT_CREATED = 'NOT_CREATED',
    VERIFYING = 'VERIFYING'
}

export enum ServiceState {
    CREATING = 'CREATING',
    VERIFYING = 'VERIFYING',
    BLOCKED = 'BLOCKED',
    PAUSED = 'PAUSED',
    INACTIVE = 'INACTIVE',
    NOT_PAID = 'NOT_PAID',
    INVALID_PAYMENT_METHOD = 'INVALID_PAYMENT_METHOD',
    ACTIVE = 'ACTIVE',
    NO_CAMPAIGNS = 'NO_CAMPAIGNS',
    WAITING_FOR_DATA = 'WAITING_FOR_DATA',
    WAITING_FOR_PIXEL = 'WAITING_FOR_PIXEL'
}

export interface ServiceCurrentState {
    state: ServiceState;
    color: StateType;
    name: string;
    description: string;
    priority: number;
}

export interface ServiceFullStatus {
    status: ServiceStatus;
    info: string;
    color: StatusType;
}
